import { render } from "./SiteHeader.vue?vue&type=template&id=d5924aa6&scoped=true"
import script from "./SiteHeader.vue?vue&type=script&lang=js"
export * from "./SiteHeader.vue?vue&type=script&lang=js"

import "./SiteHeader.vue?vue&type=style&index=0&id=d5924aa6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5924aa6"]])

export default __exports__